import { createI18n } from "vue-i18n";

import de from "./de.json";
import en from "./en.json";
import tr from "./tr.json";

const numberFormats = {
  de: {
    currency: {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    percent: {
      style: "percent",
      useGrouping: false,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
    price: {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },
};

const datetimeFormats = {
  de: {
    short: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    },
    medium: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    },
  },
};

const i18n = createI18n({
  silentTranslationWarn: true,
  fallbackLocale: "de",
  globalInjection: true,
  legacy: false,
  numberFormats,
  datetimeFormats,
  locale: "de",
  messages: { de, en, tr },
});

export default i18n;
